import AbsentInfo from './AbsentInfo';

export default AbsentInfo;
